// src-crsld/app.components.js

var components = {
  'application'         : 'application',
  'blank'               : 'blank',
  'landing'             : 'landing',
  'program-info'        : 'programinfo',
  'text-landing'        : 'textlanding',
  'video-landing'       : 'videolanding',
  'webinar'             : 'webinar'
}

export default components;
